import React, { useState, useEffect, useCallback, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import I18n from 'i18n.js.erb'

const SendEmailModal = ({
  request,
  setRequest,
  emailFrom,
  setEmailFrom,
  handleSendEmail
}) => {


  // Funzione che gestisce la chiusura della modale
  const handleClose = () => {
    setEmailFrom({ ...emailFrom, text: null })
    setRequest(null);
  }


  // Funzione che verifica se l'indirizzo email del mittente sia valido
  // e se il testo della mail sia composto da almeno 10 caratteri.
  // Se queste condizioni sono verificate, allora la mail può essere spedita
  const isValidEmail = () => {
    return (
      emailFrom &&
        emailFrom.text &&
          emailFrom.text.length > 10 &&
            emailFrom.email &&
              (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emailFrom.email))
    );
  }


  // Funzione che si occupa di gestire la conferma dell'invio email da parte dell'utente
  const handleConfirm = () => {
    handleClose()
    handleSendEmail()
  }


  return <Modal
    size="lg"
    show={ request !== null }
    onHide={ handleClose }
    animation={false}
  >
    <Modal.Body>
      <div className="d-block justify-content-start mt-2">
        <div className="mb-5">
          <label>{I18n.t('js.shopPage.yourEmailAddress')}</label>
          <input
            type="text"
            className="form-control"
            value={emailFrom.email ? emailFrom.email : ''}
            onChange={(e) => setEmailFrom({ ...emailFrom, email: e.target.value })}
          />
        </div>

        <div className="mb-5">
          <label>{I18n.t('js.shopPage.emailText')}</label>
          <textarea
            className="form-control"
            style={{ height: '300px' }}
            value={emailFrom.text ? emailFrom.text : ''}
            onChange={(e) => setEmailFrom({ ...emailFrom, text: e.target.value })}
          />
        </div>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <div className="center-btn-on-mobile">
        <button
          type="button"
          className="btn-standard-outline br-20px pr-2 pl-2 w-120px btn-standard-outline-resized mr-3"
          onClick={ handleClose }>
          {I18n.t('js.common.button.cancel')}
        </button>
        <button
          type="button"
          className="btn-standard bg-aig-gradient text-light br-20px pr-2 pl-2 w-150px btn-standard-resized pt-4px-imp h-35px"
          onClick={ handleConfirm }
          disabled={!isValidEmail()}
        >
          <i className="fas fa-paper-plane mr-2"></i>
          {I18n.t('js.shopPage.sendEmail')}
        </button>
      </div>
    </Modal.Footer>
  </Modal>
};

export default SendEmailModal;